export default function OutlinedDeviceIcon({
  size = 24,
  width,
  height,
  name,
  ...rest
}: {
  size?: number;
  name?: string;
  width?: number;
  height?: number;
  [key: string]: any;
}) {
  return (
    <svg
      {...rest}
      width={width || size}
      height={height || width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill="#282828" />
      {name === "tactosy-for-arms" && (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.71253 9.25005L6.30571 14.75H9.00495V9.25005H6.71253Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.6928 16.75H10.3072C9.61162 16.75 9.04831 16.3065 9.01187 15.75H6.23176L6.12918 17.1392C6.06479 18.009 6.75189 18.75 7.62244 18.75H16.3773C17.2481 18.75 17.9352 18.009 17.8708 17.1392L17.768 15.75H14.9881C14.9519 16.3138 14.3859 16.75 13.6928 16.75Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.995 9.25V14.75H17.6942L17.2874 9.25H14.995Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.3071 7.25H13.6927C14.3856 7.25 14.9514 7.6955 14.9881 8.25H17.2136L17.0943 6.63925C17.0364 5.856 16.385 5.25 15.601 5.25H8.39907C7.61488 5.25 6.96347 5.856 6.90556 6.63925L6.78651 8.25H9.01179C9.04773 7.6955 9.60181 7.25 10.3071 7.25Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.1284 8.25H10.8715C10.3853 8.25 10.0034 8.625 10.0034 9.08325V14.9167C10.0034 15.377 10.392 15.75 10.8715 15.75H13.1284C13.6059 15.75 13.9967 15.3832 13.9967 14.9167V9.08325C13.9967 8.625 13.6059 8.25 13.1284 8.25Z"
            fill="white"
          />
        </>
      )}
      {name === "tactsuit" && (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.25 5.25H8.0885C8.36475 5.25 8.5885 5.47028 8.5885 5.74224V7.72549C8.5885 7.88301 8.69425 8.02182 8.848 8.06587L11.2783 8.69324C11.432 8.73754 11.5377 8.87611 11.5377 9.03387V18.2622C11.5377 18.5317 11.3158 18.75 11.0423 18.75H9.56075C8.996 18.75 8.4475 18.5639 8.00275 18.2213L6.657 17.1849C6.0845 16.7439 5.75 16.0683 5.75 15.3528V5.74224C5.75 5.47028 5.97375 5.25 6.25 5.25Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.75 5.25H15.9115C15.6352 5.25 15.4115 5.47028 15.4115 5.74224V7.72549C15.4115 7.88301 15.3057 8.02182 15.152 8.06587L12.7217 8.69324C12.568 8.73754 12.4622 8.87611 12.4622 9.03387V18.2575C12.4622 18.5295 12.6862 18.75 12.9625 18.75H14.4117C14.9942 18.75 15.5603 18.558 16.019 18.2046L17.3125 17.2085C17.9043 16.7527 18.25 16.0542 18.25 15.3144V5.74224C18.25 5.47028 18.0263 5.25 17.75 5.25Z"
            fill="white"
          />
        </>
      )}
    </svg>
  );
}
